import React, {useEffect, useState, useContext} from "react";
import Column from "@meridian/components/column";
import {AppNavigationContext} from "../appNavigation/context/AppNavigationContext";
import {SALPrinterContext} from "./context/SALPrinterContext";
import {SALPrinterActions} from "./actions/SALPrinterActions";
import {FormattedMessage, injectIntl} from "react-intl";
import {ScanWithCodeView} from "dolphin-meridian-react-components";
import packageScanImage from "../../images/ic_package_scan.png";
import Footer from "../commons/Footer";
import {StoreKeys} from "../utils/StoreKeys";
import {onChangePrinterResponse} from "./utils/utils";

const ScanPrinterView = (props) => {
    const dispatchPrinter = useContext(SALPrinterContext).dispatchPrinter;
    const {navState: {helpOptions : {open: helpOpen}}, navActions: {setupHelp, onBackDefault, resetNavCol}} = useContext(AppNavigationContext);

    const [alert, setAlert] = useState(null);

    const inductLocation = props.match.params.inductLocation;

    const onScanPrinter = (printerSerial) => {
        dispatchPrinter({
            type: SALPrinterActions.CHANGE_PRINTER,
            data: printerSerial
        });
    }

    const checkQueryParams = () => {
        // Page refreshed on scan from Avery and printer serial sent in query param
        const moduleInitializationParams = JSON.parse(localStorage.getItem(StoreKeys.MODULE_INITIALIZATION_PARAMS));
        if (moduleInitializationParams && moduleInitializationParams.scan_value && moduleInitializationParams.scan_value !== "null") {
            onScanPrinter(moduleInitializationParams.scan_value);
        }
        if (moduleInitializationParams && moduleInitializationParams.change_printer_response && moduleInitializationParams.change_printer_response !== "null") {
            onChangePrinterResponse(moduleInitializationParams, props, setAlert, resetNavCol, dispatchPrinter);
        }
    }

    const onCancelScan = () => {
        props.history.goBack();
    }

    useEffect(() => {
        onBackDefault();
        setupHelp(true, {list: []});
        checkQueryParams();
    }, []);

    return (
        <Column height="100%" spacing="none" spacingInset="none">
            {alert}
            <Column height="100%" spacingInset="small">
                <ScanWithCodeView
                    primaryTitle={{
                        title: props.intl.formatMessage({id: "printer.grab_new_printer"}),
                    }}
                    secondaryTitle={{
                        title: props.intl.formatMessage({id: "printer.scan_printer"}),
                        size: "Large",
                        type: "Bold"
                    }}
                    image={packageScanImage}
                    button={{
                        title: props.intl.formatMessage({id: "printer.cancel_change_printer"}),
                        onClick: onCancelScan
                    }}
                    onSubmit={onScanPrinter}
                    focusLock={!helpOpen}
                />
            </Column>
            <Footer>
                <FormattedMessage id={"induct.location_inducted"} values={{"location": inductLocation}} />
            </Footer>
        </Column>
    )
}

export default injectIntl(ScanPrinterView);


// WEBPACK FOOTER //
// ./src/components/scanPrinter/ScanPrinterView.js